<template>
  <div>
    <div class="dashboard-head-bg"/>
    <div class="dashboard-head-content">
      <DashboardHeader :firstname=firstname :profile-picture-url=profilePictureUrl />
      <div class="dashboard-status">
        <div class="dashboard-status-content">

          <div v-if="statutEntretien == 'Prévu' || statutEntretien == 'Proposé'" class="dashboard-status-content-label">
            Convocation entretien de motivation
          </div>
          <div v-else class="dashboard-status-content-label">
            En cours de qualification
          </div>
          <div class="dashboard-status-content-progress">
            <ve-progress
                :progress="purcentage"
                :size="100"
                color="#CBDB2A"
                emptyThickness="10%"
                line="square"
                thickness="10%"
            >
              <span class="dashboard-status-content-progress-legend">{{ purcentage }}%</span>
            </ve-progress>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-container">
      <div class="dashboard-section" v-if="comments !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Un commentaire a été déposé sur votre espace</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{comments}}</pre>
          </div>
        </div>
      </div>

      <div class="dashboard-section" v-if="ofVacationDateAsString !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Congés annuels de votre centre de rattachement</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{ ofVacationDateAsString }}</pre>
          </div>
        </div>
      </div>

      <div v-if="statutEntretien == 'Prévu' || statutEntretien == 'Proposé' || hasBookedPublicMeeting" class="dashboard-section">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Important</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div v-if="hasBookedPublicMeeting" class="dashboard-section-content-italic dashboard-public-meeting-info">
            <p class="dashboard-public-meeting-info-label" v-html="bookedPublicMeetingLabel"></p>

            <div class="dashboard-public-slot-main">
              <p class="dashboard-public-slot-head">
                <strong>{{ formatPublicSlot(bookedPublicMeeting) }}</strong>
              </p>

              <div
                  v-if="bookedPublicMeeting?.meetLink"
                  class="dashboard-public-slot-meet-link"
              >
                <strong style="margin-right: 12px">Lien de la visio : </strong>
                <a
                    :href="bookedPublicMeeting.meetLink"
                    class="dashboard-public-slot-meet-link-anchor"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                  <i class="bi bi-camera-video-fill" aria-hidden="true"/>
                  <span>{{ bookedPublicMeeting.meetLink }}</span>
                </a>
              </div>

              <address
                  v-else-if="bookedPublicMeeting?.planning?.ofCandidatureMeeting"
                  class="dashboard-public-slot-address"
              >
                <p class="dashboard-public-slot-location">{{ getPublicMeetingLocation(bookedPublicMeeting) }}</p>
                <div class="dashboard-public-slot-address-line">
                  <span class="dashboard-public-slot-address-pin">📍</span>
                  <div>
                    {{ bookedPublicMeeting.planning.ofCandidatureMeeting.campusAddress }}<br>
                    <span class="dashboard-public-slot-address-city">
                      {{ bookedPublicMeeting.planning.ofCandidatureMeeting.campusPostalCode }}
                      {{ bookedPublicMeeting.planning.ofCandidatureMeeting.campusCityName }}
                    </span>
                  </div>
                </div>
              </address>
            </div>

            <p class="dashboard-public-meeting-warning">
              L'absence injustifiée à l'entretien engendrera une suppression du dossier de candidature.
            </p>
          </div>
          <div v-else class="dashboard-section-content-italic">
            Vous êtes convoqué par :<br>
            {{ textCampusConvocation }}<br>
            <br>
            <span class="dashboard-section-content-bold">Le {{ textDateConvocation }}</span>
          </div>
        </div>
      </div>

      <div v-else class="dashboard-section">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Important</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div v-if="showInterviewCalendarButton" class="form-group">
            <div class="dashboard-section-content-italic">
              Vous pouvez dès à présent accéder au planning des entretiens pour choisir une date d'entretien de motivation.
            </div>
            <button class="btn btn-primary btn-block" type="button" @click="toInterviewFile">
              <span>Accéder au planning des entretiens</span>
            </button>
          </div>
          <div v-else class="dashboard-section-content-italic">
            Vous allez recevoir une convocation à un entretien de motivation par email, d'ici 10 jours ouvrés.
            <span style="color:red; font-weight: bold"><br/>L'absence injustifiée à l'entretien engendrera une suppression du dossier de candidature</span>
          </div>
        </div>
      </div>

      <EmployerSearch :profilViewedCount=profilViewedCount />
    </div>
  </div>
</template>

<script>

import DashboardHeader from '@/components/Dashboard/Header.vue'
import EmployerSearch from '@/components/Dashboard/EmployerSearch.vue'
import PlanningApi from "@/api/PlanningApi";
import dayjs from "dayjs";
import "dayjs/locale/fr";

dayjs.locale("fr");

export default {
  name: "DashboardQualifying",
  components: {
    DashboardHeader,
    EmployerSearch
  },
  props: {
    firstname: String,
    purcentage: Number,
    profilViewedCount: Number,
    textDateConvocation: String,
    textCampusConvocation: String,
    statutEntretien: String,
    comments: String,
    ofVacationDateAsString: String,
    profilePictureUrl: String,
  },
  data() {
    return {
      bookedPublicMeeting: null,
      hasPublicMeetingSlots: false
    }
  },
  computed: {
    hasBookedPublicMeeting() {
      return Boolean(this.bookedPublicMeeting?.id)
    },
    bookedPublicMeetingLabel() {
      const status = Number(this.bookedPublicMeeting?.statut)

      if (status === 20) {
        return "Votre rendez-vous est en attente de confirmation, s'il est confirmé vous allez recevoir prochainement une convocation par email.<br/>Sur le créneau choisi suivant :"
      }

      if (status === 30) {
        return "Nous sommes dans l'attente d'une confirmation de votre part, merci de consulter votre boîte email.<br/>Créneau concerné :"
      }

      if (status === 40) {
        return "Vous avez rendez-vous,"
      }

      if (status === 50) {
        return "Vous avez refusé la proposition de rendez-vous, merci de nous contacter pour plus d'informations.<br/><a href='/messages/contact' >Messages -> Contacter mon centre Apform</a>"
      }

      if (status === 60) {
        return "Vous avez été reçu en rendez-vous le :"
      }

      if (status === 70) {
        return "Votre rendez-vous a été annulé, merci de nous contacter pour plus d'informations."
      }


      return "Vous êtes convoqué par :"
    },
    showInterviewCalendarButton() {
      return this.statutEntretien === 'Demandé' && !this.hasBookedPublicMeeting && this.hasPublicMeetingSlots
    }
  },
  methods: {
    ensureBootstrapIconsLoaded() {
      const bootstrapIconsHref = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css'
      const existingLink = document.querySelector(`link[href="${bootstrapIconsHref}"]`)

      if (existingLink) {
        return
      }

      const link = document.createElement('link')
      link.href = bootstrapIconsHref
      link.rel = 'stylesheet'
      document.head.appendChild(link)
    },
    toInterviewFile() {
      this.$router.push('/dossier')
    },
    extractBookedPublicMeeting(payload) {
      if (Array.isArray(payload)) {
        return payload.find((meeting) => meeting?.id) || null
      }

      if (!payload || typeof payload !== 'object') {
        return null
      }

      if (payload.id) {
        return payload
      }

      if (payload?.meeting?.id) {
        return payload.meeting
      }

      if (payload?.bookedMeeting?.id) {
        return payload.bookedMeeting
      }

      if (Array.isArray(payload?.meetingList)) {
        return payload.meetingList.find((meeting) => meeting?.id) || null
      }

      if (payload.data) {
        return this.extractBookedPublicMeeting(payload.data)
      }

      return null
    },
    formatPublicSlot(meeting) {
      if (!meeting?.startAt || !meeting?.endAt) {
        return ''
      }

      const start = dayjs(meeting.startAt).locale('fr')
      const end = dayjs(meeting.endAt).locale('fr')

      const formatHour = (d) => (d.minute() === 0 ? d.format('H[h]') : d.format('H[h]mm'))

      return `Le ${start.format('dddd D MMMM YYYY')} de ${formatHour(start)} à ${formatHour(end)}`
    },
    getPublicMeetingLocation(meeting) {
      return meeting?.planning?.ofCandidatureMeeting?.ofName || 'Lieu à confirmer'
    },
    async fetchInterviewPlanningState() {
      const [bookedMeetingResult, publicMeetingsResult] = await Promise.allSettled([
        PlanningApi.getBookedPublicMeeting(),
        PlanningApi.getPublicMeetingsByCandidacy()
      ])

      if (bookedMeetingResult.status === 'fulfilled') {
        this.bookedPublicMeeting = this.extractBookedPublicMeeting(bookedMeetingResult.value?.data)
      } else {
        this.bookedPublicMeeting = null
      }

      if (publicMeetingsResult.status === 'fulfilled') {
        const publicMeetingList = publicMeetingsResult.value?.data?.meetingList || []
        this.hasPublicMeetingSlots = Array.isArray(publicMeetingList) && publicMeetingList.length > 0
      } else {
        this.hasPublicMeetingSlots = false
      }
    }
  },
  mounted() {
    this.ensureBootstrapIconsLoaded()
    this.fetchInterviewPlanningState()
  }
};
</script>

<style scoped>
.dashboard-public-meeting-info-separator {
  border: 0.1px dashed #dadde1;
  margin-bottom: 15px;
}

.dashboard-public-meeting-info-label {
  margin: 0 0 10px 0;
}

.dashboard-public-slot-main {
  margin-bottom: 15px;
}

.dashboard-public-slot-head {
  margin: 0 0 3px 0;
}

.dashboard-public-slot-location {
  color: #676767;
  font-size: 0.9rem;
  margin: 0 0 4px 0;
}

.dashboard-public-slot-address {
  font-style: normal;
  margin: 0;
}

.dashboard-public-slot-address-line {
  align-items: baseline;
  display: flex;
  gap: 8px;
}

.dashboard-public-slot-address-pin {
  color: #e63946;
  flex-shrink: 0;
  font-size: 1.1em;
}

.dashboard-public-slot-address-city {
  color: #666;
}

.dashboard-public-slot-meet-link {
  margin: 0 0 4px 0;
}

.dashboard-public-slot-meet-link-anchor {
  align-items: center;
  color: #0e6076;
  display: inline-flex;
  gap: 0.4rem;
  text-decoration: none;
  word-break: break-all;
}

.dashboard-public-slot-meet-link-anchor:hover {
  text-decoration: underline;
}

.dashboard-public-meeting-warning {
  margin: 0;
}
</style>
